import { Check, Close, DeleteOutline, Edit } from "@mui/icons-material";
import {
  Grid2 as Grid,
  Typography,
  IconButton as MuiIconButton,
  Box,
  Stack,
} from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { FC, useState } from "react";
import { EConfirmModalType } from "src/shared/components";
import { preparePhoneForView } from "src/shared/helpers/phone.helpers";
import { renderLabeledValues } from "src/shared/helpers/render.helpers";
import { useConfirmModal } from "src/shared/hooks";
import { Can } from "src/shared/lib/rback/Can";
import { IPartnerContactDTO } from "src/shared/types/partner.types";
import { useDeletePartnerContactMutation } from "../../model/api/partners";
import { EditContactModal } from "../EditContactModal/EditContactModal";
interface IContactPersonItemProps {
  contactPerson: IPartnerContactDTO;
}
export const ContactPersonItem: FC<IContactPersonItemProps> = ({
  contactPerson,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [deleteContact, { isLoading: isLoadingDelete }] =
    useDeletePartnerContactMutation();

  const handleDeleteContact = async (closeModal: () => void) => {
    try {
      await deleteContact({
        partnerId: String(contactPerson.partner_id),
        contactId: String(contactPerson.id),
      }).unwrap();
      enqueueSnackbar("Контакт успешно удален", {
        variant: "success",
        handleClose: closeSnackbar,
      });
      closeModal();
    } catch (e) {
      enqueueSnackbar("Произошла ошибка при удалении контакта", {
        variant: "error",
        handleClose: closeSnackbar,
      });
      console.log(e);
    }
  };

  const { modal, showModal } = useConfirmModal({
    onResolve: ({ closeModal }) => handleDeleteContact(closeModal),
    confirmModalType: EConfirmModalType.DELETE,
    confirmBtnProps: { isLoading: isLoadingDelete, title: "Удалить" },
    title: `Удалить ${contactPerson.lastname} ${contactPerson.firstname}?`,
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        gap: 4,
        pb: 4,
      }}
    >
      <Grid container spacing={4} flex={1}>
        {contactPerson.is_main_contact && (
          <Grid size={12}>
            <Typography
              variant="body2"
              sx={{
                color: "grey.500",
              }}
            >
              Основное контактное лицо:
            </Typography>
          </Grid>
        )}
        {renderLabeledValues(
          [
            { label: "Фамилия", value: contactPerson.lastname },
            { label: "Имя", value: contactPerson.firstname },
            { label: "Пол", value: contactPerson.sex.name },
            {
              label: "Должность",
              value: contactPerson.position?.name,
            },
            { label: "Email", value: contactPerson.email },
            {
              label: "Основной телефон",
              value: preparePhoneForView(contactPerson.phone_main),
            },
            {
              label: "Дополнительный телефон",
              value: preparePhoneForView(contactPerson.phone_additional),
            },
            {
              label: "Skype",
              value: contactPerson.messengers?.[0]?.login,
            },
            {
              label: "QA обзвон",
              value: contactPerson.feedback_call_consent ? (
                <Check color="success" />
              ) : (
                <Close color="error" />
              ),
            },
            {
              label: "ЛПР",
              value: contactPerson.is_decision_maker ? (
                <Check color="success" />
              ) : (
                <Close color="error" />
              ),
            },
          ],
          { breakValues: true },
        )}
      </Grid>
      <Stack
        direction={"row"}
        spacing={1}
        sx={{
          minWidth: 72,
          marginLeft: "auto",
        }}
      >
        <>
          <Can perform={["partners.edit", "partners.edit.team"]}>
            <MuiIconButton
              size="small"
              color="inherit"
              sx={{ minWidth: 0, color: "grey.500" }}
              onClick={() => setIsEditModalOpen(true)}
            >
              <Edit />
            </MuiIconButton>
          </Can>

          {isEditModalOpen ? (
            <EditContactModal
              open
              onClose={() => setIsEditModalOpen(false)}
              contactId={contactPerson.id}
            />
          ) : null}
        </>
        {!contactPerson.is_main_contact && (
          <Can perform={["partners.edit", "partners.edit.team"]}>
            <MuiIconButton
              size="small"
              color="inherit"
              sx={{ minWidth: 0, color: "grey.600" }}
              onClick={() => showModal()}
            >
              <DeleteOutline color="inherit" />
            </MuiIconButton>
          </Can>
        )}
      </Stack>
      {modal}
    </Box>
  );
};
